<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-card title="Genel Bilgi">
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <title-text />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <pcode-text />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <department-select />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <team-select />
          </b-col>
          <b-col cols="12">
            <description-text />
          </b-col>
          <b-col cols="12">
            <notes-text />
          </b-col>
        </b-row>
      </b-card>
      <b-alert
        v-if="!checkCodeResult.status"
        show
        variant="danger"
      >
        <div class="alert-body text-center">
          {{ checkCodeResult.message }}
        </div>
      </b-alert>
      <div v-else>
        <save-button
          :save-action="submitForm"
          :is-disabled="submitStatus"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BAlert,
} from 'bootstrap-vue'
import PcodeText from '@/views/Projects/elements/ProjectCard/PcodeText.vue'
import TitleText from '@/views/Projects/elements/ProjectCard/TitleText.vue'
import DescriptionText from '@/views/Projects/elements/ProjectCard/DescriptionText.vue'
import NotesText from '@/views/Projects/elements/ProjectCard/NotesText.vue'
import DepartmentSelect from '@/views/Projects/elements/ProjectCard/DepartmentSelect.vue'
import TeamSelect from '@/views/Projects/elements/ProjectCard/TeamSelect.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'ProjectCard',
  components: {
    ValidationObserver,
    SaveButton,
    BCard,
    BRow,
    BCol,
    BAlert,
    PcodeText,
    TitleText,
    DescriptionText,
    NotesText,
    DepartmentSelect,
    TeamSelect,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
    checkCodeResult() {
      return this.$store.getters['projects/checkCodeResult']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/projects/edit/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
    localize('tr')
  },
  methods: {
    getDataItem() {
      if (this.$route.params.id) {
        this.$store.dispatch('projects/getDataItem', this.$route.params.id)
          .then(response => {
            if (response.id_departments) {
              this.getTeams()
            }
          })
      }
    },
    getTeams() {
      if (this.dataItem.id_departments) {
        this.$store.dispatch('teams/getDataList', {
          select: [
            'teams.id AS id',
            'teams.title AS title',
          ],
          where: {
            'teams.status': 1,
            'teams.id_departments': this.dataItem.id_departments,
          },
        })
      } else {
        this.dataItem.id_teams = null
      }
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('projects/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
